import {
    UPDATE_GPS_LOCATION,
  } from "../store/types";
  
  const INITIAL_STATE = {
    location: null,
    error:false
  }
export const gpsreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_GPS_LOCATION:
            if (action.payload && action.payload.lat) {
                return { location: action.payload, error: false };
            } else if (action.payload && action.payload.error === false) {
                return { ...state, error: false };
            } else {
                return { location: null, error: true };
            }
        default:
            return state;
    }
};